// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2V8ie","importantInfo":"styles_importantInfo__2ZV-M"};